import apiClient from './api/client';

export interface CampaignMarketplace { id: string; name: string; available: boolean; note?: string }

export interface Campaign {
  marketplace: string;
  id: string;
  type: string;
  typeLabel: string;
  name: string;
  status: string;
  startDate?: string | null;
  endDate?: string | null;
  deadlineDate?: string | null;
  meliPercent?: number | null;
  sellerPercent?: number | null;
  /** seller = lojista informa o preço · fixed = desconto definido pelo marketplace */
  priceMode: 'seller' | 'fixed';
}

export interface CampaignItem {
  itemId: string;
  title: string;
  sku: string;
  thumbnail: string;
  permalink: string;
  status: string;
  price: number | null;
  originalPrice: number | null;
  suggestedPrice: number | null;
  minPrice: number | null;
  maxPrice: number | null;
  meliPercent: number | null;
  sellerPercent: number | null;
  offerId: string;
  inQflow?: boolean;
  qflowTitle?: string;
  qflowPrice?: number;
}

export interface JoinResult { itemId: string; ok: boolean; message: string }

const err = (e: any, fallback: string) => new Error(e?.response?.data?.error || e?.message || fallback);

export const CampaignService = {
  async marketplaces(): Promise<CampaignMarketplace[]> {
    try { return (await apiClient.get('/campaigns/marketplaces')).data; }
    catch (e) { throw err(e, 'Erro ao carregar marketplaces'); }
  },

  async list(marketplace: string): Promise<Campaign[]> {
    try { return (await apiClient.get('/campaigns', { params: { marketplace } })).data.campaigns || []; }
    catch (e) { throw err(e, 'Erro ao carregar campanhas'); }
  },

  async items(c: Campaign, status = '', cursor = ''): Promise<{ items: CampaignItem[]; total?: number; nextCursor: string }> {
    try {
      return (await apiClient.get(`/campaigns/${c.marketplace}/${encodeURIComponent(c.id)}/items`,
        { params: { type: c.type, status, cursor }, timeout: 60000 })).data;
    } catch (e) { throw err(e, 'Erro ao carregar itens da campanha'); }
  },

  async join(c: Campaign, items: Array<{ itemId: string; price?: number; offerId?: string }>) {
    try {
      return (await apiClient.post(`/campaigns/${c.marketplace}/${encodeURIComponent(c.id)}/items`,
        { type: c.type, items }, { timeout: 120000 })).data as { ok: number; total: number; results: JoinResult[] };
    } catch (e) { throw err(e, 'Erro ao inscrever itens'); }
  },

  async leave(c: Campaign, item: CampaignItem): Promise<JoinResult> {
    try {
      return (await apiClient.delete(`/campaigns/${c.marketplace}/${encodeURIComponent(c.id)}/items/${item.itemId}`,
        { params: { type: c.type, offerId: item.offerId || undefined } })).data;
    } catch (e) { throw err(e, 'Erro ao remover item'); }
  },
};
